<div class="container">
  <div class="image-container">
    <!-- <img src="assets/main-gate-small-final.png" alt="" class="gate-img" /> -->
    <picture>
      <source 
        srcset="assets/main-gate-small-final.png 1200w"
        media="(min-width: 1201px)"
      />
      <img src="" alt="Example image" class="gate-img">
    </picture>
  </div>

  <div class="profile-container">
    <div class="header">
      <img
        style="cursor: pointer"
        src="assets/apps-icon.svg"
        alt=""
        height="32px"
        width="32px"
        (click)="toggleShowApps()"
      />
    </div>
    @if(showApps){
       <div #popup class="all-apps">
        <div class="all-apps-container">
          <div class="app-image-container" (click)="clickApps(orgUrl)">
            <img src="assets/org-icon.svg" />
          </div>
      @if(memberDetails.country !== "NEPAL"){
        <div
          class="app-image-container"
          (click)="clickApps(accoUrl)"
        >
          <img src="assets/acco-icon.svg" />
        </div>
        <div class="app-image-container" (click)="clickApps(onlineIvUrl)">
          <img src="assets/phil-icon.svg" />
        </div>
      }
      </div>
    </div>
    } @if(memberDetails){

    <div style="overflow-y: auto">
      <div class="profile-header">
        <img src="assets/profile.png" alt="Profile" class="profile-pic" />
        <div class="title">Jayguru 🙏🏻 {{ getFullName() }}</div>
      </div>

      <div class="details-card">
        <div class="card-header">Personal Details</div>
        <div class="card-body" [formGroup]="profileForm">
          <div class="form-row">
            <div class="form-group">
              <label>First Name</label>
              <input
                type="text"
                [value]="memberDetails.firstName || ''"
                #firstNameInput
                [disabled]="true"
              />
            </div>
            <div class="form-group">
              <label>Middle Name</label>
              <input type="text" [value]="memberDetails.middleName || ''" [disabled]="true" />
            </div>
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" [value]="memberDetails.lastName || ''" [disabled]="true" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label
                >Phone Number
                <!-- <small style="color: green;">(Verified)</small> -->
              </label>
              <input
                type="text"
                formControlName="contactNo"
                (input)="onNumberChange($event)"
                (click)="onNumberChange($event)"
                [readonly]="true"
                maxlength="10"
              />
            </div>
            @if(isUpdateNo){
            <div class="form-group">
              <label>Verify Otp</label>
              <input
                type="text"
                formControlName="otp"
                (input)="onOtpVerify()"
                [readonly]="!isEditMode"
                maxlength="6"
              />
            </div>
            }
            <div class="form-group">
              <label>Ritwik Name</label>
              <input type="text" [value]="memberDetails.ritwikName" [disabled]="true" />
            </div>
            <div class="form-group">
              <label>Email Address</label>
              <input type="text" formControlName="email" [readonly]="true" [disabled]="true" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Family Code</label>
              <input type="text" formControlName="familyCode" [readonly]="true" [disabled]="true" />
            </div>
            <!-- <div class="form-group">
              <label>Philanthropy Name</label>
              <input type="text" formControlName="middleName" [readonly]="!isEditMode" />
            </div> -->
          </div>
        @if(memberDetails.country !== 'NEPAL'){
          <div class="form-row">
            <div class="form-group">
              <label>PAN Number</label>
              <input type="text" formControlName="panNo" [readonly]="!isEditMode" />
            </div>
            <div class="form-group">
              <label>Aadhar Number</label>
              <input type="text" formControlName="aadharNo" [readonly]="!isEditMode" />
            </div>
          </div>
        }
        </div>
      </div>

      <div class="details-card">
        <div class="card-header">Address Details</div>
        <div class="card-body" [formGroup]="profileForm">
          <div class="form-row">
            <div class="form-group">
              <label>Address</label>
              <input type="text" formControlName="addressLine1" [readonly]="!isEditMode" />
            </div>
            <div class="form-group">
              <label>Land Mark</label>
              <input type="text" formControlName="addressLine2" [readonly]="!isEditMode" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Pin code</label>
              <input
                type="text"
                formControlName="pincode"
                [readonly]="!isEditMode"
                (input)="onPincodeInput($event)"
                maxlength="6"
              />
            </div>
            <div class="form-group">
              <label>State</label>
              @if (allStates.length < 2) {
              <input type="text" formControlName="state" [readonly]="!isEditMode" />
              }@else {
              <select id="state" formControlName="state" (change)="onChangeState($event)">
                <option value="" disabled>Select State</option>
                @for (state of allStates; track $index) {
                <option value="{{ state }}">{{ state }}</option>
                }
              </select>
              }
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>District</label>
              @if(allDistricts.length < 2){
              <input type="text" formControlName="district" [readonly]="!isEditMode" />
              }@else{
              <select
                id="district"
                formControlName="district"
                (change)="onChangeDistrict($event, profileForm.getRawValue().state)"
              >
                <option value="" disabled>Select District</option>
                @for(districts of allDistricts; track districts){
                <option value="{{ districts }}">{{ districts }}</option>
                }
              </select>
              }
            </div>
            <div class="form-group">
              <label>Post Office</label>
              @if(allPostOffices.length < 2){
              <input type="text" formControlName="postOffice" [readonly]="!isEditMode" />
              }@else{
              <select id="district" formControlName="postOffice">
                <option value="" disabled>Select District</option>
                @for(po of allPostOffices; track po){
                <option value="{{ po }}">{{ po }}</option>
                }
              </select>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="display: flex; justify-content: space-between">
        @if(!isEditMode){
        <button class="edit-btn" (click)="enableEdit()">Edit Details</button>

        }@else {
        <button class="edit-btn" (click)="updateProfile()">Update Profile</button>
        }
        <button class="edit-btn" (click)="logOut()">Logout</button>
      </div>
    </div>
    }
  </div>
</div>
